export default "__VITE_ASSET__CdAyPLbk__"